import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldValuesTableComponent } from '../field-values-table/field-values-table.component';

@Component({
  selector: 'vdms-hq-selectors-field-values-admin-table',
  templateUrl: './field-values-admin-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FieldValuesTableComponent],
})
export class FieldValuesAdminTableComponent {}
